import { EventEmitter } from '@angular/core';


export type ExpanderSide = 'left' | 'top' | 'right' | 'bottom';
export type ExpanderDirection = 'right' | 'down' | 'left' | 'up';
export class DragNExpandMgr {
	private gutter: HTMLDivElement;
	private opened = true;
	private collapsed = false;
  public caretOn:ExpanderDirection;
  public caretOff:ExpanderDirection;

	private grip: HTMLButtonElement;
	private expander: HTMLDivElement;
	private side: ExpanderSide
	private direction: 'horizontal' | 'vertical';
	private readonly template = `
<button class="btn btn-md btn-primary thumb grip [extra]">
    <div class="fas fa-grip-lines"></div>
    <div class="fas fa-grip-lines"></div>
  </button>
  <div class="btn btn-primary thumb expander [extra]">
    <div class="caret fas"></div>
  </div>
</div>`;
	private gutterId: number;
	get gutterNum() {
		return this.gutterId;
	};
	get isOpened() {
		return this.opened;
	}
	get isCollapsed() {
		return this.collapsed;
	}
	public click = new EventEmitter<DragNExpandMgr>();
	constructor(gutter: HTMLDivElement, gutterNum: number, side: ExpanderSide) {
		this.gutter = gutter;
		this.side = side;
		this.gutterId = gutterNum;
		this.Setup();

	}
	Setup() {
		if (!this.gutter.firstChild) {
			window.requestAnimationFrame(() => {
				this.Setup();
			})
		}
		this.gutter.textContent = '';
		let direction: 'vertical' | 'horizontal' = 'vertical';

		switch (this.side) {
			case 'right':
			case 'left':
				direction = 'vertical';
				break;
			case 'top':
			case 'bottom':
				direction = 'horizontal';
		}
		this.direction = direction;
		this.gutter.innerHTML = this.template.replace(/\[extra\]/g, direction + ' ' + this.side);
		this.grip = this.gutter.firstElementChild as HTMLButtonElement;
		// this.grip.addEventListener('click', (event) => {

		// });
		this.expander = this.gutter.children[1] as HTMLDivElement;
		this.expander.addEventListener('click', (event) => {
			this.opened = !this.opened;
			this.click.emit(this);
		});
		this.SetIcon();

	}
	Collapse() {
		this.collapsed = true;
		this.Refresh();
	}
	Expand() {
		this.collapsed = false;
		this.Refresh();
	}
	Refresh() {
		this.SetIcon();
	}
	SetIcon() {
		if (!this.expander) return;
		switch (this.direction) {
			case 'horizontal':
				this.opened = !(this.gutter.parentElement.clientHeight - 132 > this.gutter.offsetTop);
				break;
			case 'vertical':
				if (this.side === 'left') {
					this.opened = !(this.gutter.offsetLeft < 170);
				} else {
					this.opened = !(this.gutter.parentElement.clientWidth - 170 < this.gutter.offsetLeft);
				}
				break;
		}
		let caretOnDirection:ExpanderDirection = 'up';

		let caretOffDirection:ExpanderDirection = 'down';
		this.grip.classList.toggle('collapsed', false);
		switch (this.side) {
			case 'right':
				this.collapsed = this.grip.offsetTop <= 1;
				caretOnDirection = (this.opened === true) ? 'up' : 'down';
				caretOffDirection = (this.opened === true) ? 'down' : 'up';
        this.caretOn = (this.opened === true) ? 'left' : 'right';
        this.caretOff = (this.opened === true) ? 'right' : 'left';

				break;
			case 'left':
				this.collapsed = this.grip.offsetTop <= 1;
				caretOnDirection = (this.opened === true) ? 'up' : 'down';
				caretOffDirection = (this.opened === true) ? 'down' : 'up';
				this.caretOn = (this.opened === true) ?  'right' : 'left';
        this.caretOff = (this.opened === true) ? 'left' : 'right';

        break;
			case 'top':
				this.collapsed = this.grip.offsetLeft <= 1;
				caretOnDirection = (this.opened === true) ? 'down' : 'up';
				caretOffDirection = (this.opened === true) ? 'up' : 'down';
        this.caretOn = caretOnDirection;
        this.caretOff = caretOffDirection;;

				break;
			case 'bottom':
				this.collapsed = this.grip.offsetLeft <= 1;
				caretOnDirection = (this.opened === true) ? 'up' : 'down';
				caretOffDirection = (this.opened === true) ? 'down' : 'up';
        this.caretOn = caretOnDirection;
        this.caretOff = caretOffDirection;;
				break;
		}

		(this.expander.firstElementChild as HTMLDivElement).classList.toggle('fa-caret-' + caretOnDirection, true);
		(this.expander.firstElementChild as HTMLDivElement).classList.toggle('fa-caret-' + caretOffDirection, false);
		this.grip.classList.toggle('collapsed', this.isCollapsed);

	}

}
